import { Icon } from "./Icon";
import { ContactForm } from "./ContactForm";
import "./styles/ContactSection.css";

export function ContactSection() {
  return (
    <section className="contact container" aria-labelledby="contact-title">
      <div className="contact__layout">
        <div className="contact__copy">
          <p className="eyebrow">Contact us</p>
          <h1 id="contact-title" className="page-header__title">Questions? Say hello</h1>
          <p className="section__lead">
            Wondering if SENfully is right for your family, or need a hand with something? Send us a message and a real person will get back to you.
          </p>
          <p className="contact__note"><Icon name="mail" size={18} /> We reply to the email address you give us.</p>
        </div>

        <div className="contact__card">
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
